
import React, { useReducer } from "react";
import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import FigureItem  from "components/FigureItem";

import { withRouterJim } from "router/withRouterJim";

//--- CONTEXT API -----------
import { useStore, useDispatch, StoreContext } from "store/StoreProvider";
import {types, storeReducer} from "store/StoreReducer"


import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";

const cbo=[
  {  value:'1', label: 'label1'},
]


const initialForm = {
  idd:0,
  ope:'n',
  
};

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class CalificacionEst extends React.Component {
  state = {

    modalImagen: false,
        
    form: Object.assign({}, initialForm),
    promedio_tareas:0,
    data: [],/* lista  */
    data2:[],
    
  };
   //---------------- CONTEXT API ------------------
    //const store = useStore();
    

  //---------------------------------
  componentDidMount() {
    //--limpiamos el array de prueba
    this.setState({data:[]});
    
    this.cargar_data();

    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');
  
    
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    
    //--- esto lo hacemos porque en vez de utilizar valores true, false
    //--- tenemos que utilizar 1, 0
    if(e.target.type==="checkbox"){

      let res = e.target.checked? 1:0;        
      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };
  //-------------------------------------------
  /*
    "id_mate": 20,
    "id_carre": 4,
    "id_cate": 99,
    "sigla": "SIM-101",
    "nombre": "SEGURIDAD INDUSTRIAL Y MEDIO AMBIENTE",
    "fecha_ini": null,
    "fecha_fin": null,
    "visible_sn": 0,
    "id_grupo": 1,
    "id_siseval": 0,
    "foto": "",
    "resumen": "",
    "estado": 0
   */
  cargar_data=()=>{
    console.log("cargar_data")
    let id_est = this.props.store.user.id_est;
    let id_mate = this.props.store.materia.id_mate;
    /*let id_peri = this.props.store.user.id_peri;
    let periodo = this.props.store.user.periodo;*/

    let param = { 
      id_est: id_est,
      id_mate: id_mate,
    }
    console.log(param)
    axios2.post("calificacion_est_get_list", param)
    .then(res => {
        console.log(res.data)
        if(res.data.length>0){ 
            this.setState({ data: res.data.collection });
            this.setState({ data2: res.data.collection2 });
            this.setState({ promedio_tareas: res.data.promedio_tareas });
        }else{
            NotificationManager.error('No existen datos');
        }
    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });
  }
  //-----------------------------------------
  // retorna id_mate, nombre, sigla
  onClickArticle=(item)=>{
    console.log("onClickArticle");
    console.log(item)
    //guardamos el usuario en el localstorage
    //localStorage.setItem("materia", JSON.stringify(item));
    //---------- lo colocamos a el STORE ------------------ 
    let materia = { id_mate:item.id_mate, nombre: item.nombre, sigla: item.sigla ,grupo: item.id_grupo, foto: item.foto }
    this.props.dispatch({ type: types.setMateria, payload: materia }); 
    //dispatch({type: types.authLogin, payload: response.user}); 
    //----------  -----------------------------------------

    let ruta = `/curso_main/${item.id_mate}`;
    //--redireccionamos
    this.props.navigate(ruta);

  }
  //------------------------------
  render() {
    return(
      <div>
        {/* ---   --- */}
        { //JSON.stringify(this.state.form)
        }
        <h5 className="titulo3">Mis calificaciones</h5>

        <div className="table-responsive">

          <div className="table-wrapper">
              <div className="table-title"><b>Examenes</b>
                  {/*<!--<div className="row">
                      <div className="col-sm-8"><h2></b></h2></div>
                      <div className="col-sm-4">
                          <button type="button" className="btn btn-info add-new">
                            <i className="fa fa-plus"></i> Add New</button>
                      </div>
                  </div>-->*/}
              </div>
              <table className="table table-striped table-hover">
                  <thead>
                      <tr>
                          <th>Título</th>
                          <th>Nota</th>
                          <th>Comentario</th>
                          <th>Acciones</th> 
                      </tr>
                  </thead>
                  <tbody>
                    {this.state.data.map((item,index) => ( 
                      <tr  key={index}>
                          <td>{ item.titulo }</td>
                          <td>{ item.nota }</td>
                          <td>{ item.comentario }</td>
                          <td>{ item.id_estadoex }</td>
                          <td>
                              {/*<?php 
                              $id_estadoex2= $item['id_estadoex2'];
                              $permiteverexa_sn= $item['permiteverexa_sn'];

                              $cad= cEstado::estado_examen2($id_estadoex2);
                              echo $cad;
                              $id_exaest = $item['id_exaest'];
                              ?>*/}

                              <a href="estu_revisa_examen/{{$id_exaest}}" className="edit-modal btn btn-warning ">
                                  { (item.permiteverexa_sn==0) &&
                                      <i className="fa fa-lock"></i>
                                  }
                                  Ver examen
                              </a>
                          </td>
                      </tr>
                    ))}
                      
                  </tbody>
              </table>
          </div>

        </div>
      
        {/*<!--     ---------------------------------------------    -->*/}
        <div className="table-wrapper">
          <div className="table-title"><b>Tareas</b>

          </div>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Nro</th>
                <th>titulo</th>
                <th>Nota</th>
                <th>Comentario</th>
                {/*<!--<th>Acciones</th>-->*/}
              </tr>
            </thead>
            <tbody>
            {this.state.data2.map((item,index) => ( 
              <tr key={index}>
                <td></td>
                <td>{ item.titulo }</td>
                <td>{ item.nota }</td>
                <td>{ item.comentario }</td>
                {/*<!--<td>
                  <a className="add" title="" data-toggle="tooltip" data-original-title="Add"><i className="material-icons">Ver Examen</i></a>

                </td>-->*/}
              </tr>
              ))}

            </tbody>
            <tfood>
              <tr>
                
                <td colspan="3"><b>Nota ponderada sobre 10pts= { this.state.promedio_tareas } Puntos</b></td>
                

              </tr>
            </tfood>
          </table>
        </div>

        <NotificationContainer />
      </div >
    )
  }
}

//------------para que soporte la funcionalidad de parametros
export default withRouterJim(CalificacionEst);